module.exports = __webpack_public_path__ + "img/vue.791e63f2.svg";